import React, { useEffect, useRef, useState } from "react";
import { obterPessoasAutorizadas } from "../../../api/requisicoes/pessoas";
import useInterceptarVoltar from "../../../components/InterceptarVolta";
import Loading from "../../../components/Loading";
import iconeVoltar from "../../../assets/icone-voltar.webp";
import "./style.css";

const normalizarTexto = (valor) =>
    typeof valor === "string"
        ? valor
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
              .toLowerCase()
        : "";

const VisitantesAutorizadosEntradaMobile = ({ setActiveComponent }) => {
    const [visitantes, setVisitantes] = useState([]);
    const [filtro, setFiltro] = useState("");
    const [cartaoExpandido, setCartaoExpandido] = useState(null);
    const [carregando, setCarregando] = useState(false);
    const [erroCarregamento, setErroCarregamento] = useState("");
    const toqueInicial = useRef({ x: 0, y: 0 });

    useInterceptarVoltar("registro-entrada", setActiveComponent);

    useEffect(() => {
        let componenteAtivo = true;

        const carregarVisitantes = async () => {
            setCarregando(true);

            try {
                const dados = await obterPessoasAutorizadas();

                if (componenteAtivo) {
                    setVisitantes(dados);
                }
            } catch (erro) {
                console.error("Erro ao buscar visitantes autorizados:", erro);

                if (componenteAtivo) {
                    setErroCarregamento(
                        "Não foi possível carregar os visitantes autorizados."
                    );
                }
            } finally {
                if (componenteAtivo) {
                    setCarregando(false);
                }
            }
        };

        carregarVisitantes();

        return () => {
            componenteAtivo = false;
        };
    }, []);

    const voltarParaRegistro = () => {
        if (window.history.state?.manual) {
            window.history.back();
            return;
        }

        setActiveComponent("registro-entrada");
    };

    const iniciarGesto = (evento) => {
        const toque = evento.touches[0];
        toqueInicial.current = { x: toque.clientX, y: toque.clientY };
    };

    const finalizarGesto = (evento) => {
        const toque = evento.changedTouches[0];
        const deslocamentoHorizontal = toque.clientX - toqueInicial.current.x;
        const deslocamentoVertical = toque.clientY - toqueInicial.current.y;

        if (
            deslocamentoHorizontal > 70 &&
            Math.abs(deslocamentoHorizontal) >
                Math.abs(deslocamentoVertical) * 1.2
        ) {
            voltarParaRegistro();
        }
    };

    const visitantesFiltrados = visitantes.filter((visitante) =>
        normalizarTexto(visitante.nomeCompleto).includes(
            normalizarTexto(filtro)
        )
    );

    return (
        <div
            className="visitantesAutorizadosEntradaMobile-tela"
            onTouchStart={iniciarGesto}
            onTouchEnd={finalizarGesto}
        >
            {carregando && <Loading />}

            <header className="visitantesAutorizadosEntradaMobile-header">
                <button
                    type="button"
                    className="visitantesAutorizadosEntradaMobile-voltar"
                    onClick={voltarParaRegistro}
                    aria-label="Voltar para registro de entrada"
                >
                    <img src={iconeVoltar} alt="" />
                </button>
                <h1>Visitantes Agendados</h1>
            </header>

            <div className="visitantesAutorizadosEntradaMobile-conteudo">
                <input
                    type="search"
                    className="visitantesAutorizadosEntradaMobile-pesquisa"
                    placeholder="Pesquisar por nome..."
                    value={filtro}
                    onChange={(evento) => setFiltro(evento.target.value)}
                />

                <div className="visitantesAutorizadosEntradaMobile-lista">
                    {erroCarregamento ? (
                        <p className="visitantesAutorizadosEntradaMobile-mensagem">
                            {erroCarregamento}
                        </p>
                    ) : !carregando && visitantesFiltrados.length === 0 ? (
                        <p className="visitantesAutorizadosEntradaMobile-mensagem">
                            Nenhum visitante agendado encontrado.
                        </p>
                    ) : (
                        visitantesFiltrados.map((visitante, indice) => {
                            const identificador =
                                visitante.id !== undefined &&
                                visitante.id !== null
                                    ? `id-${visitante.id}`
                                    : `indice-${indice}`;
                            const expandido =
                                cartaoExpandido === identificador;

                            return (
                                <div
                                    className="visitantesAutorizadosEntradaMobile-card"
                                    key={identificador}
                                >
                                    <button
                                        type="button"
                                        className="visitantesAutorizadosEntradaMobile-cardHeader"
                                        onClick={() =>
                                            setCartaoExpandido(
                                                expandido
                                                    ? null
                                                    : identificador
                                            )
                                        }
                                        aria-expanded={expandido}
                                    >
                                        <strong>
                                            {visitante.nomeCompleto || "-"}
                                        </strong>
                                        <span>{visitante.empresa || "-"}</span>
                                    </button>

                                    {expandido && (
                                        <div className="visitantesAutorizadosEntradaMobile-detalhes">
                                            <p>
                                                <strong>Responsável:</strong>{" "}
                                                {visitante.responsavel || "-"}
                                            </p>
                                            <p>
                                                <strong>Horário:</strong>{" "}
                                                {visitante.horarioVisita || "-"}
                                            </p>
                                        </div>
                                    )}
                                </div>
                            );
                        })
                    )}
                </div>
            </div>
        </div>
    );
};

export default VisitantesAutorizadosEntradaMobile;
